import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'Components/forms/text-field/TextField';
import moment from 'moment';
import RightArrowIcon from 'Components/icons/right-arrow-icon/RightArrowIcon';
import LeftArrowIcon from 'Components/icons/left-arrow-icon/LeftArrowIcon';

import './YearMonthInput.scss';

class YearMonthPicker extends Component {

  constructor(props) {
    super(props);

    const validatedDateFormat = ['MM-YYYY', 'MMM-YYYY', 'YYYY-MM'].includes(this.props.dateFormat)
      ? this.props.dateFormat
      : 'MM-YYYY';

    this.state = {
      noOfYears: this.props.noOfYears,
      currentYear: moment().year(),
      selectedValue: this.props.currentValues.v1 || '',
      isVisible: false,
      dateFormat: validatedDateFormat,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillReceiveProps(nextProps) {
    this.setDefaultValueIfSpecified(nextProps.currentValues, this.state.dateFormat);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  onClick = () => {
    if (!this.state.isVisible) {
      this.toggleVisibility();
    }
  }

  showPreviousYear = () => {
    if (this.state.currentYear > moment().subtract(this.state.noOfYears - 1, 'year').format('YYYY')) {
      this.setState({ currentYear: Number(moment([this.state.currentYear]).subtract(1, 'year').format('YYYY')) });
    }
  }

  showNextYear = () => {
    if (this.state.currentYear < moment().year()) {
      this.setState({ currentYear: Number(moment([this.state.currentYear]).add(1, 'year').format('YYYY')) });
    }
  }

  handleMonthSelection = (event) => {
    const month = event.target.getAttribute('data');
    const year = this.state.currentYear;
    const value = moment([year, month]).format(this.state.dateFormat);
    this.setState({ selectedValue: value });
    this.toggleVisibility();
    this.props.handleMonthChange(this.props.id, value);
  }

  handleOutsideClick = (event) => {
    if (this.yearMonthPicker && !this.yearMonthPicker.contains(event.target) && this.state.isVisible) {
      this.toggleVisibility();
    }
  }

  showYear = (value) => {
    const year = moment(value, this.state.dateFormat).year();
    if (year <= moment().year() && year >= moment().subtract(this.state.noOfYears - 1, 'year').format('YYYY')) {
      this.setState({ currentYear: year });
    }
  }

  showMonths = () => {
    const months = [];
    const m = moment().month('January');
    for (let i = 0; i < 12; i++) {
      let month = null;
      if (this.state.currentYear === moment().year()
        && m.month() > moment().month()) {
        month = (<li key={m.month()} className="month disable"><div data={m.month()}>{m.format('MMM')}</div></li>);
      } else {
        let monthCSS = 'month';
        if (this.state.selectedValue === moment([this.state.currentYear, m.month()]).format(this.state.dateFormat)) {
          monthCSS = `${monthCSS} currentMonth`;
        }
        month = (<li key={m.month()} className={monthCSS}><div data={m.month()} role="presentation" onClick={this.handleMonthSelection}>{m.format('MMM')}</div></li>);
      }
      m.add(1, 'month');
      months.push(month);
    }
    return months;
  }

  handleChange = (event) => {
    const validDate = moment(event.target.value, this.state.dateFormat, true);
    this.setState({ selectedValue: event.target.value });
    if (validDate.isValid()) {
      this.props.handleMonthChange(this.props.id, event.target.value);
      this.showYear(event.target.value);
    }
  }

  toggleVisibility = () => {
    this.setState({ isVisible: !this.state.isVisible });
  }


  setDefaultValueIfSpecified=(currentValues, dateFormat) => {
    if (currentValues.v1 !== undefined) {
      let parsedStart;
      if (currentValues.v1 === 'last_month') {
        parsedStart = moment().add(-1, 'months').format(dateFormat).toString();
      } else if (currentValues.v1 === 'this_month') {
        parsedStart = moment().format(dateFormat).toString();
      }
      this.setState({ selectedValue: parsedStart || currentValues.v1 });
    } else {
      this.setState({ selectedValue: '' });
    }
  };

  render() {
    return (
      <div className="year-month-picker" ref={(ref) => { this.yearMonthPicker = ref; }}>
        <TextField htmlFor={this.props.title} labelContent={this.props.title} error={this.props.error} >
          <input
            type="text"
            name="month-year-picker-input"
            id={this.props.id}
            className="field-input"
            placeholder={this.props.placeholder}
            value={this.state.selectedValue}
            onClick={this.onClick}
            onChange={this.handleChange}
          />
          {this.state.isVisible &&

            <div className="calender">
              <div className="calender-header">
                <div className="items prev " onClick={this.showPreviousYear}><LeftArrowIcon /></div>
                <div className="items">{this.state.currentYear}</div>
                <div className="items prev " onClick={this.showNextYear}><RightArrowIcon /></div>
              </div>
              <div className="months">
                <ul>
                  {this.showMonths()}
                </ul>
              </div>
            </div>
          }
        </TextField>
      </div>
    );
  }
}

YearMonthPicker.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  handleMonthChange: PropTypes.func.isRequired,
  noOfYears: PropTypes.number,
  placeholder: PropTypes.string,
  title: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
  currentValues: PropTypes.string.isRequired,
};

YearMonthPicker.defaultProps = {
  defaultDate: '',
  noOfYears: 3,
  dateFormat: 'MM-YYYY',
  placeholder: 'Select month year',
};

export default YearMonthPicker;
